import { Link } from "react-router-dom";
import { rankArticles, editorPicks } from "@/mocks/articles";

const rankColor = ["bg-accent-500", "bg-primary-500", "bg-primary-400", "bg-secondary-500", "bg-secondary-400"];

export default function HotRankSection() {
  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 rounded-md bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-900">
              <i className="ri-fire-line" />
              热门推荐
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              今日热门榜单
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
              反映当下大家都在关注、愿意分享的好料，更新快、视角广，
              帮你时刻踩准「现在最值得看」的内容节奏。
            </p>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 rounded-md bg-background-50 px-3 py-2 text-xs font-medium text-foreground-500 sm:flex whitespace-nowrap">
            <i className="ri-refresh-line text-accent-600" /> 榜单每日 18:00 刷新
          </span>
        </div>

        <div className="mt-10 grid gap-8 lg:grid-cols-12">
          {/* 榜单列表 */}
          <div className="lg:col-span-8">
            <ol className="divide-y divide-background-200/80 overflow-hidden rounded-xl border border-background-200/80 bg-background-50">
              {rankArticles.map((a, idx) => {
                const heat = 96 - idx * 14;
                return (
                  <li key={a.slug}>
                    <Link
                      to={`/article/${a.slug}`}
                      className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100/70 md:gap-6 md:px-6"
                    >
                      <span
                        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-heading text-lg font-black text-background-50 md:h-11 md:w-11 ${
                          rankColor[idx] ?? "bg-primary-500"
                        }`}
                      >
                        {idx + 1}
                      </span>
                      <div className="min-w-0 flex-1">
                        <h3 className="truncate font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                          {a.title}
                        </h3>
                        <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                          <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                            {a.categoryName}
                          </span>
                          <span>{a.author} 编辑</span>
                          <span className="hidden sm:inline">·</span>
                          <span className="hidden sm:inline">{a.readTime} 读完</span>
                        </div>
                        {/* 热度条 */}
                        <div className="mt-2 hidden h-1 w-full max-w-xs overflow-hidden rounded-full bg-background-200 md:block">
                          <div
                            className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                            style={{ width: `${heat}%` }}
                          />
                        </div>
                      </div>
                      <span className="hidden shrink-0 items-center gap-1 text-xs font-medium text-foreground-400 sm:flex">
                        <i className="ri-fire-fill text-accent-500" /> 热度 {heat}
                      </span>
                      <i className="ri-arrow-right-line shrink-0 text-foreground-300 transition-colors group-hover:text-primary-600" />
                    </Link>
                  </li>
                );
              })}
            </ol>
          </div>

          {/* 编辑力荐速览 */}
          <div className="lg:col-span-4">
            <div className="rounded-xl border border-background-200/80 bg-background-50 p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-star-line text-accent-500" />
                编辑力荐速览
              </h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                主编私藏，值得多花几分钟慢慢读的好料。
              </p>
              <ul className="mt-5 space-y-4">
                {editorPicks.slice(0, 3).map((a) => (
                  <li key={a.slug}>
                    <Link
                      to={`/article/${a.slug}`}
                      className="group block rounded-lg border border-background-200/70 p-3.5 transition-colors hover:border-accent-300 hover:bg-accent-50/50"
                    >
                      <span className="text-xs font-semibold text-accent-700">{a.categoryName}</span>
                      <p className="mt-1 font-medium leading-snug text-foreground-900 line-clamp-2 transition-colors group-hover:text-accent-800">
                        {a.title}
                      </p>
                      <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-400">
                        {a.author} · {a.date}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/about"
                className="mt-5 inline-flex h-10 w-full items-center justify-center gap-2 rounded-md bg-background-200/70 text-sm font-semibold text-foreground-800 transition-colors hover:bg-accent-500 hover:text-background-50 whitespace-nowrap"
              >
                认识我们的编辑团队 <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}